import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {LoadingListComponent} from "./loading-list/loading-list.component";

// Load Icon
import { defineLordIconElement } from 'lord-icon-element';
import lottie from 'lottie-web';
import {CommonModule} from "@angular/common";
import {PaginationTableComponent} from "./pagination-table/pagination-table.component";
import {NgbDropdownModule, NgbPaginationModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {LoadingPaginationComponent} from "./loading-pagination/loading-pagination.component";
import {LoadingButtonComponent} from "./loading-button/loading-button.component";
import {InputFileComponent} from "./input-file/input-file.component";
import {TruncatedTextTooltipComponent} from "./tooltip/TruncatedTextTooltipComponent";
import {CustomAutocompleteComponent} from "./custom-autocomplete/custom-autocomplete.component";
import {CustomNgSelectComponent} from "./custom-ng-select/custom-ng-select.component";
import {AutocompleteLibModule} from "angular-ng-autocomplete";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import { AdjuntoCardComponent } from './adjunto-card/adjunto-card.component';
import {SharedModule} from "../shared/shared.module";
import {ModalTrackingRegularizacionComponent} from "./modal-tracking-regularizacion/modal-tracking-regularizacion.component";



@NgModule({
  declarations: [
    LoadingListComponent,
    PaginationTableComponent,
    LoadingPaginationComponent,
    LoadingButtonComponent,
    InputFileComponent,
    TruncatedTextTooltipComponent,
    CustomAutocompleteComponent,
    CustomNgSelectComponent,
    AdjuntoCardComponent,
    ModalTrackingRegularizacionComponent
  ],
  exports: [
    LoadingListComponent,
    PaginationTableComponent,
    LoadingPaginationComponent,
    LoadingButtonComponent,
    InputFileComponent,
    TruncatedTextTooltipComponent,
    CustomAutocompleteComponent,
    CustomNgSelectComponent,
    AdjuntoCardComponent,
    ModalTrackingRegularizacionComponent
  ],
    imports: [
        CommonModule,
        NgbPaginationModule,
        NgbDropdownModule,
        NgbTooltipModule,
        AutocompleteLibModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        SharedModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {
  constructor() {
    defineLordIconElement(lottie.loadAnimation);
  }
}
